var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Check_342971",
    transform: "translate(-11.5 -11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4408",
    "data-name": "Group 4408",
    transform: "translate(11.5 11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4407",
    "data-name": "Group 4407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M41.39,16.678A16.844,16.844,0,0,0,29.011,11.5a16.774,16.774,0,0,0-12.4,5.178A16.806,16.806,0,0,0,11.5,29.011,16.81,16.81,0,0,0,16.61,41.39a16.885,16.885,0,0,0,12.4,5.11A16.956,16.956,0,0,0,41.39,41.39,16.81,16.81,0,0,0,46.5,29.011a16.806,16.806,0,0,0-5.11-12.333m-5.814,3.793a1.692,1.692,0,0,1,.659.954,1.454,1.454,0,0,1-.159,1.09L28.557,35.939a1.634,1.634,0,0,1-1.09.363,1.292,1.292,0,0,1-.727-.159,1.887,1.887,0,0,1-.659-.795L22.016,31.26a1.129,1.129,0,0,1,.068-1.817,1.179,1.179,0,0,1,.863-.363,1.006,1.006,0,0,1,.886.3l3.2,3.2,6.5-11.515a1.5,1.5,0,0,1,.931-.727A1.426,1.426,0,0,1,35.575,20.471Z",
    transform: "translate(-11.5 -11.5)",
    fill: "#f969a4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.8a41d9f6b3620af1c81727565152d0c7.svg";
export { ForwardRef as ReactComponent };